/* eslint-disable react/prop-types */

/**
 * An onEnter() function that will check if user falls into the treatment of mgm or not
 * else redirect to homepage
 */

import React from 'react'
import { Redirect } from 'react-router-dom'
import store from '../stores/configureStore'
import * as pxp from '../../lib/pxp'
import {
  hasMgmTreatmentTwo,
  hasMgmReferralLinksTreatment,
  hasMgmSuccessScreenEntryPointTreatment,
  hasMgmSuccessScreenEntryPointTwoTreatment,
  hasMgmSuccessScreenEntryPointThreeTreatment,
} from 'experiments/mgm'
import querystring from 'querystring'
import { parseSearch } from './url-utils'

export function mgmValidateRoute(props) {
  const state = store.getState()
  const rootURL = state.server.rootURL
  if (hasMgmReferralLinksTreatment()) {
    const queryParams = parseSearch(props.location.search)
    window.location.href = `/myaccount/transfer/invite-friends?${querystring.stringify(
      queryParams
    )}`
    return true
  } else if (
    !(
      pxp.isTreatment('Trmt_p2p_memeber_get_member_1') ||
      hasMgmSuccessScreenEntryPointTreatment() ||
      hasMgmSuccessScreenEntryPointTwoTreatment() ||
      hasMgmSuccessScreenEntryPointThreeTreatment() ||
      hasMgmTreatmentTwo() ||
      pxp.isTreatment('Trmt_p2p_mgm_entry_points') ||
      pxp.isTreatment('Trmt_p2p_mgm_entry_points_2')
    )
  ) {
    return <Redirect to={`${rootURL}/homepage`} />
  }
  return false
}
